/* ============================================================
   A LA VAQUERA — theme.js
   Base de la plantilla + capa Shopify (carrito AJAX, variantes,
   búsqueda predictiva). Vanilla JS, sin dependencias.
   ============================================================ */
document.documentElement.classList.add('js');

window.theme = window.theme || {};
window.theme.moneyFormat = window.theme.moneyFormat || '€{{amount_with_comma_separator}}';
window.theme.strings = window.theme.strings || {};

/* ---------- Money ---------- */
function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || window.theme.moneyFormat;
  function def(opt, d) { return (typeof opt === 'undefined' ? d : opt); }
  function withDelimiters(number, precision, thousands, decimal) {
    precision = def(precision, 2); thousands = def(thousands, ','); decimal = def(decimal, '.');
    if (isNaN(number) || number == null) return 0;
    number = (number / 100).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      c = parts[1] ? decimal + parts[1] : '';
    return dollars + c;
  }
  var value = '';
  var match = formatString.match(placeholderRegex);
  switch (match ? match[1] : 'amount') {
    case 'amount': value = withDelimiters(cents, 2); break;
    case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
    case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
    case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
    case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
    default: value = withDelimiters(cents, 2);
  }
  return formatString.replace(placeholderRegex, value);
}
window.formatMoney = formatMoney;

/* ---------- Toast ---------- */
var _toastEl, _toastT;
function toast(msg) {
  if (!_toastEl) { _toastEl = document.createElement('div'); _toastEl.className = 'toast'; document.body.appendChild(_toastEl); }
  _toastEl.textContent = msg;
  requestAnimationFrame(function () { _toastEl.classList.add('show'); });
  clearTimeout(_toastT);
  _toastT = setTimeout(function () { _toastEl.classList.remove('show'); }, 2600);
}

/* ---------- Popup "añadido a la cesta" ---------- */
function showCartPopup(items) {
  items = (items || []).filter(Boolean);
  var el = document.getElementById('cartPopup');
  if (!el) { el = document.createElement('div'); el.id = 'cartPopup'; el.className = 'cart-popup'; document.body.appendChild(el); }
  var totalQty = items.reduce(function (s, it) { return s + (it.quantity || 1); }, 0);
  var lines = items.slice(0, 4).map(function (it) {
    var img = it.image || (it.featured_image && it.featured_image.url) || '';
    if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, '_120x150$1$2');
    var opts = (it.options_with_values || []).map(function (o) { return o.value; }).join(' · ');
    var meta = opts + (it.quantity > 1 ? (opts ? ' · ' : '') + it.quantity + ' uds' : '');
    return '<div class="cart-popup__item">' +
      (img ? '<img src="' + img + '" alt="">' : '') +
      '<div><div class="cart-popup__name">' + (it.product_title || it.title || '') + '</div>' +
      (meta ? '<div class="cart-popup__meta">' + meta + '</div>' : '') + '</div></div>';
  }).join('');
  if (items.length > 4) lines += '<div class="cart-popup__more">y ' + (items.length - 4) + ' más…</div>';
  el.innerHTML =
    '<div class="cart-popup__head"><span>✓ Añadido a la cesta' + (totalQty > 1 ? ' (' + totalQty + ')' : '') + '</span>' +
    '<button class="cart-popup__close" data-popup-close aria-label="Cerrar">&times;</button></div>' +
    '<div class="cart-popup__items">' + lines + '</div>' +
    '<div class="cart-popup__actions"><button type="button" class="btn btn--ghost" data-popup-close>Seguir comprando</button>' +
    '<a href="/cart" class="btn">Ver carrito</a></div>';
  el.querySelectorAll('[data-popup-close]').forEach(function (b) { b.addEventListener('click', function () { el.classList.remove('show'); }); });
  void el.offsetWidth; // fuerza reflow para que la transición reproduzca (rAF se pausa en pestañas ocultas)
  el.classList.add('show');
  clearTimeout(el._t);
  el._t = setTimeout(function () { el.classList.remove('show'); }, 5000);
}

/* ---------- Cart ---------- */
var Cart = {
  drawer: null, overlay: null,
  init: function () {
    this.drawer = document.getElementById('cartDrawer');
    this.overlay = document.getElementById('overlay');
    var self = this;
    var close = document.getElementById('cartDrawerClose');
    if (close) close.addEventListener('click', function () { self.closeDrawer(); });
    document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        // Si estamos en la página de carrito, deja el enlace normal.
        if (document.body.classList.contains('template-cart')) return;
        e.preventDefault(); self.openDrawer();
      });
    });
  },
  openDrawer: function () { if (!this.drawer) return; this.refresh(); this.drawer.classList.add('open'); if (this.overlay) this.overlay.classList.add('open'); document.body.style.overflow = 'hidden'; },
  closeDrawer: function () { if (!this.drawer) return; this.drawer.classList.remove('open'); if (this.overlay) this.overlay.classList.remove('open'); document.body.style.overflow = ''; },
  add: function (id, qty, btn) {
    var self = this;
    if (btn) { btn._label = btn.textContent; btn.textContent = 'Añadiendo…'; btn.disabled = true; }
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) { btn.textContent = btn._label; btn.disabled = false; }
        if (!res.ok) { toast(res.data.description || 'No se pudo añadir'); return; }
        var added = res.data.items || (res.data.id ? [res.data] : []);
        return self.refresh().then(function () { showCartPopup(added); });
      }).catch(function () { if (btn) { btn.textContent = btn._label; btn.disabled = false; } toast('Error de red'); });
  },
  change: function (line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { Cart.render(cart); return cart; });
  },
  refresh: function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { Cart.render(cart); return cart; }); },
  updateCount: function (count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count; el.hidden = count < 1;
    });
  },
  shipBar: function (total) {
    var truck = '<svg class="ship-bar__ico" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="14" height="12" rx="1"/><path d="M15 9h4l3 3v6h-7z"/><circle cx="6" cy="19" r="2"/><circle cx="18" cy="19" r="2"/></svg>';
    var threshold = parseInt(window.theme.freeShipThreshold || 0, 10);
    if (!threshold) {
      // Envío gratis en todos los pedidos: barra de confirmación
      return '<div class="ship-bar ship-bar--free">' + truck +
        '<span><strong style="font-weight:500;color:var(--ink)">Envío gratis</strong> incluido en tu pedido.</span>' +
        '<div class="ship-bar__track"><div class="ship-bar__fill" style="width:100%"></div></div></div>';
    }
    var remaining = threshold - total;
    var pct = Math.min(100, Math.round((total / threshold) * 100));
    var msg = remaining <= 0
      ? '<strong style="font-weight:500;color:var(--ink)">¡Enhorabuena! Tienes envío gratis.</strong>'
      : 'Te faltan <strong style="font-weight:500;color:var(--ink)">' + formatMoney(remaining) + '</strong> para el envío gratis.';
    return '<div class="ship-bar">' + msg + '<div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div></div>';
  },
  render: function (cart) {
    this.updateCount(cart.item_count);
    if (!this.drawer) return;
    var body = this.drawer.querySelector('.cart-drawer__body');
    var foot = this.drawer.querySelector('.cart-drawer__foot');
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Tu cesta está vacía.</p><br><a href="/collections/all" class="link-underline">Empezar a comprar</a></div>';
      foot.innerHTML = ''; return;
    }
    var html = this.shipBar(cart.total_price) + '<div class="cart__list" style="border-top:none">';
    cart.items.forEach(function (it, i) {
      var line = i + 1;
      var opts = (it.options_with_values || []).map(function (o) { return '<span>' + o.name + ': ' + o.value + '</span>'; }).join('');
      var was = (it.original_price > it.final_price) ? '<span class="was">' + formatMoney(it.original_line_price) + '</span>' : '';
      html += '<div class="cart-line" data-line="' + line + '">' +
        '<img class="cart-line__img" src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x250$1$2') : '') + '" alt="">' +
        '<div><div class="cart-line__name"><a href="' + it.url + '">' + it.product_title + '</a></div>' +
        '<div class="cart-line__meta">' + opts + '</div>' +
        '<div class="qty" data-qty data-cart-qty><button data-step="-" aria-label="Menos">−</button><span>' + it.quantity + '</span><button data-step="+" aria-label="Más">+</button></div></div>' +
        '<div class="cart-line__right"><div class="cart-line__price"><span class="now">' + formatMoney(it.final_line_price) + '</span>' + was + '</div>' +
        '<button class="cart-line__remove" data-cart-remove>Eliminar</button></div></div>';
    });
    html += '</div>';
    html += '<div class="cart-xsell" data-cart-recommend hidden></div>';
    body.innerHTML = html;
    foot.innerHTML =
      '<div class="summary__row total"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
      '<a href="/checkout" class="btn btn--block">Finalizar compra</a>' +
      '<p class="summary__note">Impuestos incluidos. Envío calculado en el pago.</p>';
    this.bindLines(body);
    fillCrossSell(body.querySelector('[data-cart-recommend]'), cart);
  },
  bindLines: function (scope) {
    scope.querySelectorAll('[data-cart-qty]').forEach(function (q) {
      var lineEl = q.closest('[data-line]');
      var line = parseInt(lineEl.getAttribute('data-line'), 10);
      var span = q.querySelector('span');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(span.textContent, 10);
          n = b.dataset.step === '-' ? n - 1 : n + 1;
          Cart.change(line, Math.max(0, n));
        });
      });
    });
    scope.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.closest('[data-line]').getAttribute('data-line'), 10);
        Cart.change(line, 0);
      });
    });
  }
};

document.addEventListener('DOMContentLoaded', function () {
  /* ---- Drawer (menú) + menú anidado — con delegación de eventos ----
     (sobrevive a recargas de sección del editor y a cualquier re-render) */
  // Mueve el drawer del menú a <body>: al estar dentro del header sticky, su wrapper crea
  // un contexto de apilamiento que lo dejaba por debajo del overlay (z-index:90) en algunos
  // navegadores (el menú se veía "apagado"). En <body> queda con su z-index:100 real.
  var _menuDrawer = document.getElementById('drawer');
  if (_menuDrawer && _menuDrawer.parentNode !== document.body) document.body.appendChild(_menuDrawer);
  function openMenu() {
    var d = document.getElementById('drawer'), o = document.getElementById('overlay');
    if (d) d.classList.add('open'); if (o) o.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    var d = document.getElementById('drawer'); if (d) d.classList.remove('open');
    var cd = document.getElementById('cartDrawer'); if (cd) cd.classList.remove('open');
    var o = document.getElementById('overlay'); if (o) o.classList.remove('open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('#menuBtn')) { e.preventDefault(); openMenu(); return; }
    if (e.target.closest('#drawerClose')) { e.preventDefault(); closeMenu(); return; }
    var overlayEl = document.getElementById('overlay');
    if (overlayEl && e.target === overlayEl) { closeMenu(); return; }
    var dnav = e.target.closest('#drawer [data-dnav]');
    if (dnav) {
      e.preventDefault();
      var item = dnav.closest('.dnav');
      if (item) item.classList.toggle('is-open');
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });

  /* ---- Carruseles ---- */
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    var track = car.querySelector('.carousel__track');
    var prev = car.querySelector('[data-prev]');
    var next = car.querySelector('[data-next]');
    if (!track) return;
    var step = function () {
      var first = track.querySelector('*');
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 20) || 20;
      var w = first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      return Math.max(w, track.clientWidth * 0.8);
    };
    var update = function () {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft < 5;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
    };
    /* En Chrome, scroll-behavior:smooth se cancela cuando el contenedor tiene
       scroll-snap, así que scrollBy({behavior:'smooth'}) no movía nada.
       Desplazamiento fiable: fijamos scrollLeft directamente (snap desactivado un instante)
       y animamos con una transición manual por pasos. */
    var snapT, tickT;
    var glide = function (dx) {
      clearTimeout(snapT); clearInterval(tickT);
      track.style.scrollSnapType = 'none';
      var maxX = track.scrollWidth - track.clientWidth;
      var startX = track.scrollLeft;
      var target = Math.max(0, Math.min(maxX, startX + dx));
      var steps = 16, i = 0;
      var ease = function (p) { return 1 - Math.pow(1 - p, 3); };
      tickT = setInterval(function () {
        i++;
        var p = i / steps;
        track.scrollLeft = startX + (target - startX) * ease(p);
        update();
        if (i >= steps) {
          clearInterval(tickT);
          track.scrollLeft = target;
          snapT = setTimeout(function () { track.style.scrollSnapType = ''; }, 60);
        }
      }, 16);
    };
    if (prev) prev.addEventListener('click', function () { glide(-step()); });
    if (next) next.addEventListener('click', function () { glide(step()); });
    track.addEventListener('scroll', update, { passive: true });
    setTimeout(update, 60);
  });

  /* ---- Galería PDP ---- */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var gmedias = gallery.querySelectorAll('.gmedia');
    var stack = gallery.querySelector('.gallery__stack');
    var dotsWrap = gallery.querySelector('[data-gallery-dots]');
    var dots = null;
    var normC = function (s) { return (s || '').toLowerCase().replace(/[#\s]/g, ''); };
    var gmMatches = function (gm, want) {
      var img = gm.querySelector('img');
      var tags = ((img && img.getAttribute('alt')) || '').match(/#\S+/g);
      return tags ? tags.some(function (t) { return normC(t) === want; }) : false;
    };
    var syncDots = function () {
      if (!dots) return;
      var vis = [].slice.call(gmedias).filter(function (g) { return !g.hidden; });
      var w = stack.clientWidth || 1;
      var idx = Math.round(stack.scrollLeft / w);
      if (idx < 0) idx = 0; if (idx > vis.length - 1) idx = vis.length - 1;
      [].forEach.call(dots, function (d) { d.classList.remove('active'); });
      var g = vis[idx]; if (g) { var oi = [].indexOf.call(gmedias, g); if (dots[oi]) dots[oi].classList.add('active'); }
    };
    // Puntos indicadores del slider móvil (ocultos en escritorio por CSS)
    if (dotsWrap && stack && gmedias.length > 1) {
      gmedias.forEach(function (gm, i) {
        var b = document.createElement('button');
        b.type = 'button';
        if (i === 0) b.className = 'active';
        b.addEventListener('click', function () { gm.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); });
        dotsWrap.appendChild(b);
      });
      dots = dotsWrap.querySelectorAll('button');
      stack.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); });
    }
    // Al cambiar de variante, lleva la imagen correspondiente a la vista (solo si no está ya visible)
    gallery._goToMedia = function (mediaId) {
      var target = null;
      gmedias.forEach(function (s) { if (s.getAttribute('data-media-id') === String(mediaId)) target = s; });
      if (!target || target.hidden) return;
      var r = target.getBoundingClientRect();
      var horiz = stack && getComputedStyle(stack).flexDirection === 'row';
      if (horiz) { target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); return; }
      if (r.top < 0 || r.top > window.innerHeight * 0.5) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    // Filtra la galería por color (hashtag #COLOR en el alt). Si el color no tiene fotos etiquetadas, muestra todas.
    gallery._filterByColor = function (color) {
      var want = normC(color);
      if (!gmedias.length || !want) return;
      var any = [].slice.call(gmedias).some(function (gm) { return gmMatches(gm, want); });
      gmedias.forEach(function (gm, i) {
        var show = any ? gmMatches(gm, want) : true;
        gm.hidden = !show;
        if (dots && dots[i]) dots[i].hidden = !show;
      });
      var first = [].slice.call(gmedias).filter(function (g) { return !g.hidden; })[0];
      if (first) {
        var horiz = stack && getComputedStyle(stack).flexDirection === 'row';
        first.scrollIntoView(horiz ? { behavior: 'auto', inline: 'center', block: 'nearest' } : { behavior: 'auto', block: 'nearest' });
      }
      syncDots();
    };
  }

  /* ---- Selección visual simple (grupos genéricos no-variante) ---- */
  document.querySelectorAll('[data-single-select]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn || btn.classList.contains('soldout')) return;
      group.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  /* ---- Tabs (Para Ella / Para Él) ---- */
  document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    var section = tabs.closest('[data-tabs-section]') || document;
    tabs.querySelectorAll('.tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.querySelectorAll('.tab').forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        var key = tab.dataset.tab;
        section.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.dataset.panel !== key; });
      });
    });
  });

  /* ---- Acordeones ---- */
  document.querySelectorAll('.acc__head').forEach(function (head) {
    head.addEventListener('click', function () {
      var acc = head.closest('.acc');
      var body = acc.querySelector('.acc__body');
      var open = acc.classList.toggle('open');
      body.style.maxHeight = open ? body.scrollHeight + 'px' : 0;
    });
  });
  document.querySelectorAll('.acc.open .acc__body').forEach(function (b) { b.style.maxHeight = b.scrollHeight + 'px'; });

  /* ---- Desplegable de Filtros (colección) ---- */
  document.querySelectorAll('[data-filters-dd]').forEach(function (wrap) {
    var btn = wrap.querySelector('[data-filters-toggle]');
    var panel = wrap.querySelector('[data-filters-panel]');
    if (!btn || !panel) return;
    var close = function () { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); };
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = !panel.hidden;
      if (isOpen) { close(); } else { panel.hidden = false; btn.setAttribute('aria-expanded', 'true'); }
    });
    panel.addEventListener('click', function (e) { e.stopPropagation(); });
    document.addEventListener('click', function () { if (!panel.hidden) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
  });

  /* ---- Wishlist (localStorage) ---- */
  var WL_KEY = 'vaq_wishlist';
  function wlGet() {
    try {
      var a = JSON.parse(localStorage.getItem(WL_KEY) || '[]');
      // solo objetos válidos (descarta formato antiguo de solo-id)
      return (a || []).filter(function (x) { return x && typeof x === 'object' && x.h; });
    } catch (e) { return []; }
  }
  function wlSet(a) { try { localStorage.setItem(WL_KEY, JSON.stringify(a)); } catch (e) {} }
  function wlIndex(a, h) { for (var i = 0; i < a.length; i++) { if (a[i].h === h) return i; } return -1; }
  function wlUpdateCount() {
    var c = wlGet().length;
    document.querySelectorAll('.wish-count').forEach(function (el) { el.textContent = c; el.hidden = c === 0; });
    return c;
  }

  document.querySelectorAll('.wish').forEach(function (w) {
    var h = w.getAttribute('data-wish');
    if (!h) return;
    if (wlIndex(wlGet(), h) > -1) w.classList.add('active');
    w.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var wl = wlGet();
      var i = wlIndex(wl, h);
      var on = i < 0;
      if (on) {
        wl.push({
          h: h,
          t: w.getAttribute('data-wish-title') || '',
          u: w.getAttribute('data-wish-url') || ('/products/' + h),
          img: w.getAttribute('data-wish-img') || ''
        });
      } else {
        wl.splice(i, 1);
      }
      wlSet(wl);
      w.classList.toggle('active', on);
      wlUpdateCount();
    });
  });
  wlUpdateCount();

  /* ---- Vista de favoritos (Mi cuenta) ---- */
  var wlHost = document.querySelector('[data-wishlist-view]');
  if (wlHost) {
    var wlEsc = function (s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
    var wlRender = function () {
      var wl = wlGet();
      if (!wl.length) {
        var shopUrl = wlHost.getAttribute('data-shop-url') || '/collections/all';
        wlHost.innerHTML = '<div class="wl-empty"><p>Aún no tienes productos en favoritos.</p>' +
          '<p class="wl-empty__hint">Pulsa el ♡ en cualquier producto para guardarlo aquí.</p>' +
          '<a href="' + shopUrl + '" class="btn btn--ghost">Explorar productos</a></div>';
        return;
      }
      var html = '<div class="wl-grid">';
      wl.forEach(function (it) {
        var url = wlEsc(it.u);
        var media = it.img
          ? '<img src="' + wlEsc(it.img) + '" alt="' + wlEsc(it.t) + '" loading="lazy" width="400" height="500">'
          : '<span class="wl-card__ph"></span>';
        html += '<article class="wl-card">' +
          '<button type="button" class="wl-card__remove" data-wl-remove="' + wlEsc(it.h) + '" aria-label="Quitar de favoritos" title="Quitar de favoritos">&times;</button>' +
          '<a href="' + url + '" class="wl-card__media">' + media + '</a>' +
          '<div class="wl-card__name"><a href="' + url + '">' + wlEsc(it.t) + '</a></div>' +
          '</article>';
      });
      html += '</div>';
      wlHost.innerHTML = html;
      wlHost.querySelectorAll('[data-wl-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var wl2 = wlGet();
          var i = wlIndex(wl2, btn.getAttribute('data-wl-remove'));
          if (i > -1) { wl2.splice(i, 1); wlSet(wl2); }
          wlUpdateCount();
          wlRender();
        });
      });
    };
    wlRender();
  }

  /* ---- Steppers genéricos (no carrito, no rejilla mayorista) ---- */
  document.querySelectorAll('[data-qty]:not([data-cart-qty]):not([data-wg-qty])').forEach(function (q) {
    if (q.closest('[data-line]')) return;
    var span = q.querySelector('span') || q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var cur = span.tagName === 'INPUT' ? span.value : span.textContent;
        var n = parseInt(cur, 10) || 1;
        n = b.dataset.step === '-' ? Math.max(1, n - 1) : n + 1;
        if (span.tagName === 'INPUT') span.value = n; else span.textContent = n;
        span.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---- Reveal on scroll ---- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .12 });
  document.querySelectorAll('.reveal').forEach(function (el, i) { el.style.transitionDelay = (i % 4 * 60) + 'ms'; io.observe(el); });

  /* ---- Carrito ---- */
  Cart.init();

  /* ---- Cabecera: barra fija; al hacer scroll queda solo el estribo ---- */
  (function () {
    var headerEl = document.querySelector('.header');
    if (!headerEl) return;
    var onScroll = function () {
      headerEl.classList.toggle('header--scrolled', (window.scrollY || window.pageYOffset || 0) > 30);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ---- Autoplay robusto del vídeo de cabecera (+ fuente móvil/escritorio) ---- */
  (function () {
    var vids = document.querySelectorAll('.hero__video');
    if (!vids.length) return;
    var isMobile = window.matchMedia('(max-width:640px)').matches;
    vids.forEach(function (v) {
      v.muted = true; v.setAttribute('muted', '');
      /* En móvil usar el vídeo vertical si está definido */
      var srcM = v.getAttribute('data-src-mobile');
      var srcD = v.getAttribute('data-src-desktop');
      var want = (isMobile && srcM) ? srcM : (srcD || '');
      if (want) {
        var s = v.querySelector('source');
        if (!s) { s = document.createElement('source'); s.type = 'video/mp4'; v.appendChild(s); }
        if (s.getAttribute('src') !== want) { s.setAttribute('src', want); v.load(); }
        var pm = isMobile ? v.getAttribute('data-poster-mobile') : null;
        if (pm) v.setAttribute('poster', pm);
      }
      var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      tryPlay();
      v.addEventListener('canplay', tryPlay, { once: true });
      v.addEventListener('loadeddata', tryPlay, { once: true });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) tryPlay(); });
      ['touchstart', 'pointerdown', 'scroll'].forEach(function (ev) {
        window.addEventListener(ev, tryPlay, { once: true, passive: true });
      });
    });
  })();

  /* ---- Slider de imágenes en tarjetas (colección) ---- */
  initCardSliders();

  /* ---- Infinite scroll (colección) ---- */
  initInfiniteScroll();

  /* ---- Añadir a la cesta (tarjetas rápido) ---- */
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var vid = btn.getAttribute('data-variant-id');
      var url = btn.getAttribute('data-product-url');
      if (vid) Cart.add(vid, 1, btn); else if (url) window.location.href = url;
    });
  });

  /* ---- Formulario de producto (PDP) ---- */
  var pform = document.querySelector('.product-form');
  if (pform) initProductForm(pform);

  /* ---- Entrega estimada (PDP) + ventas cruzadas (carrito) ---- */
  initDeliveryEstimate();
  initCartCrossSell();

  /* ---- Pedido por cantidades (mayorista) ---- */
  initWholesale();

  /* ---- Página de carrito ---- */
  if (document.body.classList.contains('template-cart')) initCartPage();

  /* ---- Búsqueda ---- */
  initSearch();

  /* ---- Barra de subcategorías (slider horizontal) ---- */
  initCategoryRail();
});

/* ============================================================
   Formulario de producto: variantes
   ============================================================ */
function initProductForm(form) {
  var jsonId = (form.getAttribute('id') || '').replace('ProductForm-', 'ProductJson-');
  var dataEl = document.getElementById(jsonId);
  var product;
  try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var variants = product.variants;
  var idInput = form.querySelector('[name="id"]');
  var priceWrap = document.querySelector('[data-price]');
  var addBtn = form.querySelector('[data-add-btn]');
  var gallery = document.querySelector('[data-gallery]');
  var selected = {};
  var colorIdx = (product.options || []).findIndex(function (n) { return /color|colour/i.test(n); });
  var sizesPanel = form.querySelector('[data-sizes-panel]');
  function closeSizesPanel() { if (sizesPanel) { sizesPanel.hidden = true; sizesPanel.classList.remove('open'); } }

  // Estado inicial desde ?variant= o primera disponible
  var params = new URLSearchParams(location.search);
  var initId = params.get('variant');
  var initVariant = initId ? variants.filter(function (v) { return String(v.id) === String(initId); })[0] : null;
  if (!initVariant) initVariant = variants.filter(function (v) { return v.available; })[0] || variants[0];
  initVariant.options.forEach(function (val, i) { selected[i] = val; });

  function currentVariant() {
    return variants.filter(function (v) {
      return v.options.every(function (val, i) { return selected[i] === val; });
    })[0];
  }

  function optionAvailable(optIndex, value) {
    // ¿existe alguna variante disponible con este valor, respetando selecciones de índices anteriores?
    return variants.some(function (v) {
      if (v.options[optIndex] !== value) return false;
      for (var i = 0; i < optIndex; i++) { if (selected[i] !== v.options[i]) return false; }
      return v.available;
    });
  }

  function renderPrice(v) {
    if (!priceWrap) return;
    if (!v) { priceWrap.innerHTML = '<span class="now">—</span>'; return; }
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    var html = '<span class="now' + (onSale ? ' red' : '') + '">' + formatMoney(v.price) + '</span>';
    if (onSale) {
      var off = Math.round((1 - v.price / v.compare_at_price) * 100);
      html += '<span class="was">' + formatMoney(v.compare_at_price) + '</span><span class="off">−' + off + '%</span>';
    }
    priceWrap.innerHTML = html;
  }

  function updateOptionStates() {
    form.querySelectorAll('[data-option-index]').forEach(function (grp) {
      var idx = parseInt(grp.getAttribute('data-option-index'), 10);
      grp.querySelectorAll('[data-value]').forEach(function (el) {
        var val = el.getAttribute('data-value');
        var isActive = selected[idx] === val;
        el.classList.toggle('active', isActive);
        if (el.tagName === 'OPTION') el.selected = isActive;
        var avail = optionAvailable(idx, val);
        el.classList.toggle('soldout', !avail && el.tagName !== 'OPTION');
      });
    });
  }

  function update() {
    var v = currentVariant();
    if (idInput && v) idInput.value = v.id;
    renderPrice(v);
    updateOptionStates();
    if (addBtn) {
      var anyAvail = variants.some(function (vv) {
        if (colorIdx >= 0 && selected[colorIdx] != null && vv.options[colorIdx] !== selected[colorIdx]) return false;
        return vv.available;
      });
      if (sizesPanel) {
        // Zara: el botón abre el panel de tallas; disponible si hay alguna talla del color
        if (!anyAvail) { addBtn.textContent = 'Agotado'; addBtn.disabled = true; }
        else { var _agp=document.querySelector('[data-price] .now.red')||document.querySelector('[data-price] .now'); addBtn.textContent = 'Añadir a la cesta' + (_agp ? ' · ' + _agp.textContent.trim() : ''); addBtn.disabled = false; }
      } else if (!v) { addBtn.textContent = 'No disponible'; addBtn.disabled = true; }
      else if (!v.available) { addBtn.textContent = 'Agotado'; addBtn.disabled = true; }
      else { var _agp=document.querySelector('[data-price] .now.red')||document.querySelector('[data-price] .now'); addBtn.textContent = 'Añadir a la cesta' + (_agp ? ' · ' + _agp.textContent.trim() : ''); addBtn.disabled = false; }
    }
    var skuEl = form.querySelector('[data-sku]');
    if (skuEl && v && v.sku) skuEl.textContent = String(v.sku).split('#')[0];
    if (v) {
      var url = new URL(location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (gallery && gallery._goToMedia && v.featured_media) gallery._goToMedia(v.featured_media.id);
    }
    // etiqueta de color
    var colorLabel = form.querySelector('[data-selected-option-0]');
    if (colorLabel) colorLabel.textContent = selected[0] || '';
    // filtra la galería por el color seleccionado (fotos con #COLOR en el alt)
    if (gallery && gallery._filterByColor && colorIdx >= 0) gallery._filterByColor(selected[colorIdx]);
  }

  form.querySelectorAll('[data-option-index]').forEach(function (grp) {
    var idx = parseInt(grp.getAttribute('data-option-index'), 10);
    if (grp.tagName === 'SELECT') {
      grp.addEventListener('change', function () { selected[idx] = grp.value; update(); });
    } else {
      grp.addEventListener('click', function (e) {
        var el = e.target.closest('[data-value]');
        if (!el || el.classList.contains('soldout')) return;
        selected[idx] = el.getAttribute('data-value'); update();
        // Zara: elegir talla en el panel añade directamente a la cesta
        if (grp.closest('[data-sizes-panel]')) {
          var v = currentVariant();
          if (v && v.available) { Cart.add(v.id, 1, addBtn); closeSizesPanel(); }
        }
      });
    }
  });

  update();

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sizesPanel) {
      // Zara: al pulsar Añadir se abre/cierra el panel de tallas (elegir talla añade)
      if (sizesPanel.hidden) { sizesPanel.hidden = false; sizesPanel.classList.add('open'); }
      else closeSizesPanel();
      return;
    }
    var v = currentVariant();
    if (!v || !v.available) return;
    Cart.add(v.id, 1, addBtn);
  });
  // cerrar el panel de tallas al clicar fuera o con Escape
  document.addEventListener('click', function (e) {
    if (sizesPanel && !sizesPanel.hidden && !e.target.closest('[data-sizes-panel]') && !e.target.closest('[data-add-btn]')) closeSizesPanel();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSizesPanel(); });
}

/* ============================================================
   Página de carrito
   ============================================================ */
function initCartPage() {
  function refreshTotals() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      Cart.updateCount(cart.item_count);
      if (cart.item_count === 0) { window.location.reload(); return; }
      // Línea de recargo (Upcharge / mws_fee): actualizar importe o quitarla si desaparece
      var feeRow = document.querySelector('[data-fee-line]');
      var feeItem = null;
      for (var fi = 0; fi < cart.items.length; fi++) {
        if (cart.items[fi].product_type === 'mws_fee_generated') { feeItem = cart.items[fi]; break; }
      }
      if (feeRow) {
        if (feeItem) {
          var fnow = feeRow.querySelector('.cart-line__price .now');
          if (fnow) fnow.textContent = formatMoney(feeItem.final_line_price);
        } else {
          feeRow.remove();
        }
      }
      var sub = document.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = formatMoney(cart.items_subtotal_price);
      var tot = document.querySelector('[data-cart-total]');
      if (tot) tot.textContent = formatMoney(cart.total_price);
      var disc = document.querySelector('[data-cart-discounts]');
      if (disc) {
        if (cart.total_discount > 0) {
          disc.hidden = false;
          var amt = disc.querySelector('[data-discount-amount]'); if (amt) amt.textContent = '−' + formatMoney(cart.total_discount);
        } else disc.hidden = true;
      }
      // ship bar
      var bar = document.querySelector('[data-ship-fill]');
      var barMsg = document.querySelector('[data-ship-msg]');
      var threshold = parseInt(window.theme.freeShipThreshold || 0, 10);
      if (bar && threshold) {
        var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
        bar.style.width = pct + '%';
        if (barMsg) barMsg.innerHTML = (cart.total_price >= threshold)
          ? '<strong style="font-weight:500;color:var(--ink)">¡Enhorabuena! Tienes envío gratis.</strong> Tu pedido supera el mínimo.'
          : 'Te faltan <strong style="font-weight:500;color:var(--ink)">' + formatMoney(threshold - cart.total_price) + '</strong> para el envío gratis.';
      }
    });
  }

  function changeLine(line, qty, row) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (qty === 0 && row) { row.remove(); }
      else if (row) {
        var it = cart.items[line - 1];
        if (it) {
          var span = row.querySelector('.qty span'); if (span) span.textContent = it.quantity;
          var now = row.querySelector('.cart-line__price .now'); if (now) now.textContent = formatMoney(it.final_line_price);
        }
      }
      refreshTotals();
      // Upcharge (recargo de equivalencia) reajusta la línea de fee de forma asíncrona: reconciliar después
      setTimeout(refreshTotals, 700);
      setTimeout(refreshTotals, 1600);
    });
  }

  document.querySelectorAll('.cart-line[data-line]').forEach(function (row) {
    var line = parseInt(row.getAttribute('data-line'), 10);
    var span = row.querySelector('.qty span');
    row.querySelectorAll('.qty button').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(span.textContent, 10);
        n = b.dataset.step === '-' ? n - 1 : n + 1;
        changeLine(line, Math.max(0, n), row);
      });
    });
    var rm = row.querySelector('.cart-line__remove');
    if (rm) rm.addEventListener('click', function () { changeLine(line, 0, row); });
  });
}

/* ============================================================
   Búsqueda predictiva
   ============================================================ */
function initSearch() {
  var openBtns = document.querySelectorAll('[data-search-open]');
  var modal = document.getElementById('searchModal');
  if (!modal) return;
  var input = modal.querySelector('input[name="q"]');
  var results = modal.querySelector('.search-results');
  var closeBtn = modal.querySelector('.search-modal__close');
  var t;
  function open() { modal.classList.add('open'); document.body.style.overflow = 'hidden'; setTimeout(function () { input.focus(); }, 120); }
  function close() { modal.classList.remove('open'); document.body.style.overflow = ''; }
  openBtns.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
  if (closeBtn) closeBtn.addEventListener('click', close);
  modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  if (!input) return;
  input.addEventListener('input', function () {
    clearTimeout(t);
    var q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; return; }
    t = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) { results.innerHTML = '<p style="color:var(--muted)">Sin resultados para “' + q + '”.</p>'; return; }
          var html = '<div class="grid4">';
          products.forEach(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            var price = p.price ? formatMoney(parseInt(String(p.price).replace('.', ''), 10)) : '';
            html += '<article class="card"><a href="' + p.url + '"><div class="card__media card__media--single">' +
              (img ? '<img class="front" src="' + img + '" alt="">' : '') + '</div>' +
              '<div class="card__cat">' + (p.type || '') + '</div>' +
              '<div class="card__name">' + p.title + '</div>' +
              '<div class="card__price"><span class="now">' + price + '</span></div></a></article>';
          });
          html += '</div><div style="margin-top:22px"><a class="link-underline" href="/search?q=' + encodeURIComponent(q) + '">Ver todos los resultados →</a></div>';
          results.innerHTML = html;
        });
    }, 220);
  });
}

/* ============================================================
   Pedido por cantidades (mayorista): todas las tallas + qty
   ============================================================ */
function initWholesale() {
  var root = document.querySelector('[data-wholesale]');
  if (!root) return;
  var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-variant-qty]'));
  var unitsEl = root.querySelector('[data-wg-units]');
  var amountEl = root.querySelector('[data-wg-amount]');
  var addBtn = root.querySelector('[data-wg-add]');
  var note = root.querySelector('[data-wg-note]');

  function recalc() {
    var units = 0, amount = 0;
    inputs.forEach(function (inp) {
      var q = parseInt(inp.value, 10) || 0;
      if (q < 0) { q = 0; inp.value = 0; }
      units += q;
      amount += q * (parseInt(inp.getAttribute('data-price'), 10) || 0);
    });
    if (unitsEl) unitsEl.textContent = units;
    if (amountEl) amountEl.textContent = formatMoney(amount);
  }

  // Steppers de la rejilla (permiten 0)
  root.querySelectorAll('[data-wg-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (input.disabled) return;
        var n = parseInt(input.value, 10) || 0;
        n = b.dataset.step === '-' ? Math.max(0, n - 1) : n + 1;
        input.value = n;
        recalc();
      });
    });
  });
  inputs.forEach(function (inp) {
    inp.addEventListener('input', recalc);
    inp.addEventListener('change', recalc);
  });

  // Selector de color: filtra las filas de tallas
  var swatches = root.querySelector('[data-wg-swatches]');
  if (swatches) {
    var label = root.querySelector('[data-wg-color-label]');
    swatches.querySelectorAll('[data-wg-color]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var color = sw.getAttribute('data-wg-color');
        swatches.querySelectorAll('[data-wg-color]').forEach(function (s) { s.classList.toggle('active', s === sw); });
        if (label) label.textContent = color;
        root.querySelectorAll('[data-wg-variant]').forEach(function (row) {
          row.hidden = row.getAttribute('data-color') !== color;
        });
      });
    });
  }

  // Añadir todas las cantidades de golpe
  function submitAdd() {
    var items = [];
    inputs.forEach(function (inp) {
      var q = parseInt(inp.value, 10) || 0;
      if (q > 0 && !inp.disabled) items.push({ id: inp.getAttribute('data-variant-qty'), quantity: q });
    });
    if (!items.length) { if (note) note.textContent = 'Indica cantidades en al menos una talla.'; return; }
    if (note) note.textContent = '';
    if (!addBtn._label) addBtn._label = addBtn.textContent;
    addBtn.textContent = 'Añadiendo…';
    addBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        addBtn.textContent = addBtn._label; addBtn.disabled = false;
        if (!res.ok) { if (note) note.textContent = res.data.description || 'No se pudo añadir'; return; }
        inputs.forEach(function (inp) { inp.value = 0; });
        recalc();
        var added = res.data.items || (res.data.id ? [res.data] : []);
        Cart.refresh().then(function () { showCartPopup(added); });
      }).catch(function () {
        addBtn.textContent = addBtn._label; addBtn.disabled = false;
        if (note) note.textContent = 'Error de red';
      });
  }
  addBtn.addEventListener('click', submitAdd);

  // Añadir uno por talla (rellena 1 en cada talla disponible del color visible y añade)
  var oneBtn = root.querySelector('[data-wg-onesize]');
  if (oneBtn) oneBtn.addEventListener('click', function () {
    var filled = 0;
    inputs.forEach(function (inp) {
      if (inp.disabled) return;
      var row = inp.closest('[data-wg-variant]');
      if (row && row.hidden) return;
      inp.value = 1;
      filled++;
    });
    recalc();
    if (filled > 0) submitAdd();
    else if (note) note.textContent = 'No hay tallas disponibles en este color.';
  });

  recalc();
}

/* ============================================================
   Slider de imágenes en tarjeta (colección/búsqueda)
   ============================================================ */
// Barra de progreso inicial de cada slider de tarjeta (idempotente).
// Las flechas y la actualización de la barra van por DELEGACIÓN (abajo),
// así funcionan siempre: colección, Novedades, búsqueda y lo que añade el scroll infinito,
// sin depender de enganchar listeners por nodo (que fallaba en las colecciones).
function cardSliderBar(sl) {
  var track = sl.querySelector('.card__slides');
  var bar = sl.querySelector('[data-card-bar]');
  if (!track || !bar) return;
  var n = sl.querySelectorAll('.card__slide').length;
  var cur = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
  bar.style.width = (((cur + 1) / Math.max(1, n)) * 100) + '%';
}
function initCardSliders(root) {
  (root || document).querySelectorAll('[data-card-slider]').forEach(cardSliderBar);
}
// Delegación global: un solo listener para TODAS las flechas de tarjeta (presentes y futuras).
document.addEventListener('click', function (e) {
  var arrow = e.target.closest ? e.target.closest('.card__arrow') : null;
  if (!arrow) return;
  var sl = arrow.closest('[data-card-slider]');
  if (!sl) return;
  e.preventDefault(); e.stopPropagation();
  var track = sl.querySelector('.card__slides');
  if (!track) return;
  var w = Math.max(1, track.clientWidth);
  var n = sl.querySelectorAll('.card__slide').length;
  var cur = Math.round(track.scrollLeft / w);
  var dir = arrow.classList.contains('card__arrow--prev') ? -1 : 1;
  var i = Math.max(0, Math.min(n - 1, cur + dir));
  track.scrollTo({ left: i * w, behavior: 'smooth' });
});
// Delegación en captura (scroll no burbujea): actualiza la barra al deslizar cualquier track.
document.addEventListener('scroll', function (e) {
  var track = e.target;
  if (!track || !track.classList || !track.classList.contains('card__slides')) return;
  var sl = track.closest('[data-card-slider]');
  if (sl) cardSliderBar(sl);
}, true);

/* ============================================================
   Infinite scroll de la colección
   ============================================================ */
function initInfiniteScroll() {
  var grid = document.getElementById('grid');
  if (!grid || grid.getAttribute('data-next-url') == null) return;
  var sentinel = document.querySelector('[data-infinite-sentinel]');
  if (!sentinel) return;
  var loader = document.querySelector('[data-infinite-loader]');
  var pager = document.querySelector('.pager');
  if (pager) pager.style.display = 'none';
  var loading = false, done = false, restoring = false;
  var stateKey = 'infscroll:' + location.pathname + location.search;

  function count() { return grid.querySelectorAll('.card').length; }

  function loadNext(cb) {
    if (loading || done) { if (cb) cb(); return; }
    var url = grid.getAttribute('data-next-url');
    if (!url) { done = true; if (cb) cb(); return; }
    loading = true;
    if (loader) loader.hidden = false;
    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.getElementById('grid');
        if (ng) {
          var kids = Array.prototype.slice.call(ng.children);
          kids.forEach(function (c) { grid.appendChild(c); });
        }
        var nn = doc.querySelector('.pager a[data-next]');
        grid.setAttribute('data-next-url', nn ? nn.getAttribute('href') : '');
        if (!nn) done = true;
        initCardSliders(grid);
        loading = false;
        if (loader) loader.hidden = true;
        if (cb) { cb(); return; }
        if (!done) {
          var r = sentinel.getBoundingClientRect();
          if (r.top < window.innerHeight + 700) setTimeout(loadNext, 120);
        }
      })
      .catch(function () { loading = false; if (loader) loader.hidden = true; if (cb) cb(); });
  }

  // Guardar posición y nº de productos cargados al salir (p.ej. al abrir un producto)
  function saveState() {
    try { sessionStorage.setItem(stateKey, JSON.stringify({ n: count(), y: window.scrollY || window.pageYOffset, t: Date.now() })); } catch (e) {}
  }
  window.addEventListener('pagehide', saveState);
  grid.addEventListener('click', function (e) { if (e.target.closest('a')) saveState(); });

  // Restaurar al volver (botón atrás): recargar las tandas y volver a la posición
  var saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(stateKey) || 'null'); } catch (e) {}
  if (saved && saved.n > count() && (Date.now() - saved.t) < 1800000) {
    restoring = true;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    if (loader) loader.hidden = false;
    (function step() {
      if (count() >= saved.n || done) {
        try { sessionStorage.removeItem(stateKey); } catch (e) {}
        if (loader) loader.hidden = true;
        restoring = false;
        window.scrollTo(0, saved.y);
        setTimeout(function () { window.scrollTo(0, saved.y); }, 80);
        return;
      }
      loadNext(step);
    })();
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting && !restoring) loadNext(); });
  }, { rootMargin: '700px 0px' });
  io.observe(sentinel);
}

/* ============================================================
   Entrega estimada (PDP): próximo día laborable
   ============================================================ */
function initDeliveryEstimate() {
  var box = document.querySelector('[data-delivery]');
  if (!box) return;
  var sp = box.querySelector('span'); if (!sp) return;
  var now = new Date();
  var before = now.getHours() < 18;
  var d = new Date(now); d.setDate(d.getDate() + (before ? 1 : 2));
  while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
  var days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var tm = new Date(now); tm.setDate(tm.getDate() + 1);
  var isTom = d.toDateString() === tm.toDateString();
  var when = (isTom ? 'mañana, ' : 'el ') + days[d.getDay()] + ' ' + d.getDate() + ' de ' + months[d.getMonth()];
  sp.innerHTML = 'Entrega estimada <strong>' + when + '</strong>' + (before ? ' si lo pides antes de las <strong>18:00</strong>.' : '.');
}

/* ============================================================
   Ventas cruzadas (carrito y drawer): recomendaciones + añadir rápido
   ============================================================ */
function fillCrossSell(container, cart) {
  if (!container || !cart || !cart.items || !cart.items.length) { if (container) container.hidden = true; return; }
  var inCart = cart.items.map(function (it) { return it.product_id; });
  var pid = cart.items[0].product_id;
  var imgSize = container.classList.contains('cart-xsell--page') ? '_600x750' : '_200x250';
  fetch('/recommendations/products.json?product_id=' + pid + '&intent=related&limit=10', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var prods = (data.products || []).filter(function (p) { return inCart.indexOf(p.id) === -1 && p.available !== false; }).slice(0, 4);
      if (!prods.length) { container.hidden = true; return; }
      var h = '<div class="cart-xsell__t">Completa tu pedido</div><div class="cart-xsell__row">';
      prods.forEach(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var price = (v.price != null) ? formatMoney(v.price) : '';
        h += '<div class="cart-xsell__it">' +
          '<a href="' + p.url + '" class="cart-xsell__ph">' + (img ? '<img src="' + img.replace(/(\.[a-z]+)(\?|$)/i, imgSize + '$1$2') + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="cart-xsell__info"><a href="' + p.url + '" class="cart-xsell__nm">' + p.title + '</a>' +
          '<span class="cart-xsell__pr">' + price + '</span></div>' +
          '<button type="button" class="cart-xsell__add" data-xsell-add="' + v.id + '" aria-label="Añadir">+</button></div>';
      });
      h += '</div>';
      container.innerHTML = h;
      container.hidden = false;
      container.querySelectorAll('[data-xsell-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var vid = btn.getAttribute('data-xsell-add');
          if (!vid || vid === 'undefined') return;
          btn.disabled = true; btn.textContent = '✓';
          if (typeof Cart !== 'undefined' && Cart.add) Cart.add(vid, 1);
        });
      });
    })
    .catch(function () { if (container) container.hidden = true; });
}

function initCartCrossSell() {
  var c = document.querySelector('[data-cart-recommend-page]');
  if (!c) return;
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { fillCrossSell(c, cart); });
}

/* ============================================================
   Barra de subcategorías: una sola línea con slider horizontal
   ============================================================ */
function initCategoryRail() {
  var wraps = document.querySelectorAll('[data-rail]');
  if (!wraps.length) return;
  wraps.forEach(function (wrap) {
    var track = wrap.querySelector('[data-rail-track]');
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      wrap.classList.toggle('can-left', track.scrollLeft > 2);
      wrap.classList.toggle('can-right', max > 2 && track.scrollLeft < max - 2);
    }
    /* Centrar la pestaña activa al cargar (si se sale de la vista) */
    var active = track.querySelector('.col-fam__link.active');
    if (active) {
      var off = active.offsetLeft - (track.clientWidth / 2) + (active.offsetWidth / 2);
      if (off > 0) track.scrollLeft = off;
    }
    update();
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    /* Rueda vertical del ratón -> desplazamiento horizontal (escritorio) */
    track.addEventListener('wheel', function (e) {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return;
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var atStart = track.scrollLeft <= 0;
      var atEnd = track.scrollLeft >= max;
      if ((e.deltaY > 0 && !atEnd) || (e.deltaY < 0 && !atStart)) {
        track.scrollLeft += e.deltaY;
        e.preventDefault();
        update();
      }
    }, { passive: false });
  });
}
